/**
 * @description Resolve the company UUID on Super Admin merchant list rows.
 *
 * Key features:
 * - Accepts camelCase companyId, legacy id, or snake_case company_id
 * - Returns empty string when none are present (drawer must not fetch)
 *
 * @dependencies
 * - None
 *
 * @notes
 * - MerchantDrawer GET /admin/companies/:id is gated on this value
 * - Settings → CMS → Merchants historically passed the list row as-is
 * - Tenants → Merchants may send id when companyId is absent
 */

/**
 * @param {object|null|undefined} merchant
 * @returns {string}
 */
export function resolveMerchantCompanyId(merchant) {
  if (!merchant || typeof merchant !== 'object') {
    return '';
  }

  const raw = merchant.companyId || merchant.id || merchant.company_id;
  if (typeof raw !== 'string') {
    return '';
  }

  return raw.trim();
}
